export default __webpack_public_path__ + "static/media/game-of-life.6c3d2ef4.jpg";